import { Axios_Post} from "../../axios";

export const getConsoleMasterData = (columnKey: string): Promise<{ status: number, values: string[] }> => {
  return Axios_Post('/v1/consoleMasterData', { columnKey })
}
